/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { CacheProvider } from '@emotion/react';
import { ThemeProvider } from '@mui/material/styles';
import ThemeVariablesRoot from './ThemeVariablesRoot';
import muiTheme from './muiTheme';
import muiCache from './emotionCache';

const PearsonThemeProvider = ({ children }) => (
  <CacheProvider value={muiCache}>
    <ThemeProvider theme={muiTheme}>
      <ThemeVariablesRoot>
        {children}
      </ThemeVariablesRoot>
    </ThemeProvider>
  </CacheProvider>
);

PearsonThemeProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

PearsonThemeProvider.defaultProps = {
  children: null
};

export default PearsonThemeProvider;
